<template>
  <div> 
    <nav-bar/>
    <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow">
      <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link navbar-text" href="#/TransferPending">
              {{$t('TransferCompleted.sidebar.pending')}}
            </a>
            <span v-if="pending.length > 0" class="pull-right badge badge-default">{{ pending.length }}</span>
          </li>
          <li class="nav-item" id="current">
            <a class="nav-link navbar-text" href="#/TransferCurrent">
              {{$t('TransferCompleted.sidebar.completed')}}
            </a>
          </li>
      </ul>
    </div>
    <div class="view">
      <div class="card mb-3 bg-darkgrey">
        <div id="stats" class="color-grey">
          <div class="col-12 col-md-6 col-lg-3">
            <p class="mx-3 my-3">{{$t('TransferCompleted.stats.processing')}}: <span class="pull-right color-white">{{ count.processing }}</span></p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="mx-3 my-3">{{$t('TransferCompleted.stats.dispatch')}}: <span class="pull-right color-white">{{ count.dispatch }}</span></p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="mx-3 my-3">{{$t('TransferCompleted.stats.pick')}}: <span class="pull-right color-white">{{ count.pick }}</span></p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="mx-3 my-3">{{$t('TransferCompleted.stats.transit')}}: <span class="pull-right color-white">{{ count.transit }}</span></p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="mx-3 my-3">{{$t('TransferCompleted.stats.delivered')}}: <span class="pull-right color-white">{{ count.drop }}</span></p>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <p class="mx-3 my-3">{{$t('Search.status.canceled')}}: <span class="pull-right color-white">{{ count.reject }}</span></p>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h3 class="my-2">{{$t('TransferCompleted.title')}}</h3>
        </div>
          <paginate name="filterResults" tag="div" :list="filterResults" class="" :per="40">
            <div class="table-responsive">
            <table class="table table-hover font-grey mb-0 table-sm">
              <thead class="bg-darkgrey">
                <tr>
                  <th></th>
                  <th @click="sortBy('transpName', false)" class="sortable nowrap">{{$t('TransferCompleted.carrier')}}<i v-if="sort.current === 'transpName'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('orderRef', false)" class="sortable nowrap">{{$t('TransferCompleted.reference')}}<i v-if="sort.current === 'orderRef'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('.key', false)" class="sortable nowrap">{{$t('TransferCompleted.order')}}<i v-if="sort.current === '.key'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('vin', false)" class="sortable nowrap">{{$t('TransferCompleted.VIN')}}<i v-if="sort.current === 'vin'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('creationDate', false)" class="sortable nowrap">{{$t('TransferCompleted.date')}}<i v-if="sort.current === 'creationDate'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('transmitterName', false)" class="sortable nowrap">{{$t('TransferCompleted.pickup')}}<i v-if="sort.current === 'transmitterName'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('receiverName', false)" class="sortable nowrap">{{$t('TransferCompleted.delivery')}}<i v-if="sort.current === 'receiverName'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                  <th @click="sortBy('status', false)" class="sortable nowrap">{{$t('TransferCompleted.status')}}<i v-if="sort.current === 'status'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                </tr>
              </thead>
              <transition-group name="fade" tag="tbody">
                <tr key='filters'>
                  <th></th>
                  <td>
                    <regular-input
                      :value="fields.transpName"
                      @input="fields.transpName = $event; filteredSearchMethod()"
                      :placeholder="$t('TransferCompleted.carrier')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.orderRef"
                      @input="fields.orderRef = $event; filteredSearchMethod()"
                      :placeholder="$t('TransferCompleted.reference')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields['.key']"
                      @input="fields['.key'] = $event; filteredSearchMethod()"
                      :placeholder="$t('TransferCompleted.order')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.vin"
                      @input="fields.vin = $event; filteredSearchMethod()"
                      :placeholder="$t('TransferCompleted.VIN')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.creationDate"
                      @input="fields.creationDate = $event; filteredSearchMethod()"
                      :placeholder="$t('TransferCompleted.date')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.transmitterName"
                      @input="fields.transmitterName = $event; filteredSearchMethod()"
                      :placeholder="$t('TransferCompleted.pickup')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.receiverName"
                      @input="fields.receiverName = $event; filteredSearchMethod()"
                      :placeholder="$t('TransferCompleted.delivery')"/>
                  </td>
                  <td>
                    <regular-input
                      :value="fields.status"
                      @input="fields.status = $event; filteredSearchMethod()"
                      :placeholder="$t('TransferCompleted.status')"/>
                  </td>
                </tr>
                <tr v-for="transfer in paginated('filterResults')" :key="transfer['.key']" :class="{'drop': transfer.status === 'Drop', 'cancel': transfer.status === 'Cancel', 'waiting': transfer.status === 'Waiting', 'pick': transfer.status === 'Pick', 'transit': transfer.status === 'Transit', 'dispatch': transfer.status === 'Dispatch', 'reject': transfer.status === 'Reject', }">
                  <td>
                    <a :href="'#/OrderInfo?orderId=' + transfer['.key']">
                      <input type="button" class="btn btn-kne-orange pull-right " :value="$t('TransferCompleted.view')">
                    </a>
                  </td>
                  <td class="nowrap"><p class="table-fix-width">{{transfer.transpName}}</p></td>
                  <td>{{transfer.orderRef}}</td>
                  <td>{{transfer['.key']}}</td>
                  <td>{{transfer.vin}}</td>
                  <td>{{getDate(transfer.creationDate)}}</td>
                  <td class="nowrap"><p class="table-fix-width">{{transfer.transmitterName}}</p></td>
                  <td class="nowrap"><p class="table-fix-width">{{transfer.receiverName}}</p></td>
                  <td>
                    <span v-if="transfer.status === 'Dispatch'">{{$t('Search.status.dispatch')}}</span>
                    <span v-if="transfer.status === 'Processing'">{{$t('Search.status.processing')}}</span>
                    <span v-if="transfer.status === 'Pick'">{{$t('Search.status.pick')}}</span>
                    <span v-if="transfer.status === 'Waiting'">{{$t('Search.status.waiting')}}</span>
                    <span v-if="transfer.status === 'Transit'">{{$t('Search.status.transit')}}</span>
                    <span v-if="transfer.status === 'Drop'">{{$t('Search.status.drop')}}</span>
                    <span v-if="transfer.status === 'Cancel'">{{$t('Search.status.canceled')}}</span>
                    <span v-if="transfer.status === 'Terminée'">{{$t('Search.status.finished')}}</span>
                    <span v-if="transfer.status === 'Transférée'">{{$t('Search.status.transfered')}}</span>
                    <span v-if="transfer.status === 'Reject'">{{$t('Search.status.rejected')}}</span>
                  </td>
                </tr>
              </transition-group>
            </table>
          </div>
        </paginate>
        <paginate-links for="filterResults" :hide-single-page="true" :limit="5"></paginate-links>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '../Modal.vue'
import regularInput from '../regularInput.vue'
import regularCheckbox from '../regularCheckbox.vue'
import regularTextarea from '../regularTextarea.vue'
import Search from '../module/Search.vue'
import {db} from '../../firebase'
import _ from 'lodash'

export default {
  name: 'transferCompleted',
  components: {
    Modal,
    regularInput,
    regularCheckbox,
    regularTextarea,
    Search
  },
  data () {
    return {
      closedModal: true,
      transfers: [],
      count: {
        processing: 0,
        dispatch: 0,
        pick: 0,
        transit: 0,
        drop: 0,
        transfer: 0,
        reject: 0
      },
      fields: {
        transpName: '',
        orderRef: '',
        '.key': '',
        vin: '',
        creationDate: '',
        transmitterName: '',
        receiverName: '',
        status: ''
      },
      filterResults: [],
      paginate: ['filterResults'],
      sort: {
        current: '.key',
        desc: true
      }
    }
  },
  methods: {
    filteredSearchMethod: _.debounce(function () {
      this.filterResults = []
      this.filterResults = this.transfers.filter((entry) => {
        var result = true
        for (var attr in this.fields) {
          if (this.fields[attr] !== '') {
            var reg = this.fields[attr].replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
            var re = new RegExp(reg, 'i')
            if (attr === 'creationDate') {
              let date = this.getDate(entry[attr])
              result = re.test(date)
            } else if (attr === 'status') {
              if (entry.status === 'Dispatch') result = re.test(this.$t('Search.status.dispatch'))
              else if (entry.status === 'Pick') result = re.test(this.$t('Search.status.pick'))
              else if (entry.status === 'Processing') result = re.test(this.$t('Search.status.processing'))
              else if (entry.status === 'Waiting') result = re.test(this.$t('Search.status.waiting'))
              else if (entry.status === 'Transit') result = re.test(this.$t('Search.status.transit'))
              else if (entry.status === 'Drop') result = re.test(this.$t('Search.status.drop'))
              else if (entry.status === 'Cancel') result = re.test(this.$t('Search.status.canceled'))
              else if (entry.status === 'Terminée') result = re.test(this.$t('Search.status.finished'))
              else if (entry.status === 'Transférée') result = re.test(this.$t('Search.status.transfered'))
              else if (entry.status === 'Reject') result = re.test(this.$t('Search.status.rejected'))
              else result = false
            } else {
              result = re.test(entry[attr])
            }
          }
          if (result === false) break
        }
        return result
      })
      this.filterResults.reverse()
      this.sortBy(this.sort.current, true)
    }, 100),
    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString()
    },
    counts () {
      for (var attr in this.count) this.count[attr] = 0
      this.transfers.forEach((o) => {
        if (o.status === 'Processing') this.count.processing++
        if (o.status === 'Dispatch') this.count.dispatch++
        if (o.status === 'Pick') this.count.pick++
        if (o.status === 'Transit') this.count.transit++
        if (o.status === 'Drop') this.count.drop++
        if (o.status === 'Transférée') this.count.transfer++
        if (o.status === 'Cancel') this.count.reject++
      })
    },
    sortBy (criteria, newEntry) {
      if (this.sort.current === criteria && !newEntry) {
        this.sort.desc = !this.sort.desc
      } else if (!newEntry) {
        this.sort.desc = true
        this.sort.current = criteria
      }
      this.filterResults.sort((a, b) => {
        if (a[criteria] === undefined) a[criteria] = ''
        if (b[criteria] === undefined) b[criteria] = ''
        var A = a[criteria]
        var B = b[criteria]
        if (criteria !== 'creationDate' && criteria !== '.key') {
          A = a[criteria].toUpperCase() // ignore upper and lowercase
          B = b[criteria].toUpperCase() // ignore upper and lowercase
        } else {
          A = parseInt(a[criteria])
          B = parseInt(b[criteria])
        }
        if (!this.sort.desc) {
          if (A < B) {
            return -1
          }
          if (A > B) {
            return 1
          }
        } else {
          if (A > B) {
            return -1
          }
          if (A < B) {
            return 1
          }
        }
        // names must be equal
        return 0
      })
    }
  },
  watch: {
    transfers: function () {
      this.counts()
    }
  },
  created () {
    this.$bindAsArray('transfers', db.ref('test/transporter/' + this.companyUID + '/currentTransfer'), null, () => {
      this.filteredSearchMethod()
      this.counts()
    })
    this.$bindAsArray('pending', db.ref('test/transporter/' + this.companyUID + '/pendingTransfer'))
  },
  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
input, button{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// TransferCompleted.vue?71a30b46